export var E_IDENTITY_STATUS;
(function (E_IDENTITY_STATUS) {
    E_IDENTITY_STATUS[E_IDENTITY_STATUS["FEB_EXCEPTION"] = 0] = "FEB_EXCEPTION";
    E_IDENTITY_STATUS["TO_STUDY"] = "READY_FOR_STUDY";
    E_IDENTITY_STATUS["NEVER_COMPLETED"] = "INITIATED";
    E_IDENTITY_STATUS["VALID"] = "ACCEPTED";
    E_IDENTITY_STATUS["INCOMPLETE"] = "INCOMPLETE";
    E_IDENTITY_STATUS["FRAUD"] = "REFUSED";
})(E_IDENTITY_STATUS || (E_IDENTITY_STATUS = {}));
